var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g({staticClass:"icon-flag-badge"},_vm.listeners),[_c('div',{staticClass:"pole"}),_c('div',{staticClass:"flag"},[_c('div',{staticClass:"flag-number"},[_vm._v("\n      "+_vm._s(_vm.props.number)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }